import styled from "styled-components";
import { Button as ButtonComponent } from "ui";
import Card from "ui/Card";
import DeleteIconSvg from "core/icons/ClassSetting/DeleteIcon.svg?react";
import TrashIconSvg from "core/icons/trash/trash_3.svg?react";
import DownloadIconSvg from "core/icons/download/download.svg?react";
import { getMarginStyle, getPaddingStyle, SpacingStyle } from "core/styles/paddingMarginStyle";

type CardType = SpacingStyle & {
  width?: string;
  iconDelete?: "delete" | "trash";
};

export const CardStyled = styled(Card)<CardType>`
  position: relative;
  background-color: ${({ theme }) => theme?.colors?.white};
  min-width: 160px;
  width: ${({ width }) => width || "fit-content"};
  max-width: ${({ width, iconDelete }) =>
    width ? "unset" : iconDelete === "delete" ? "240px" : "295px"};
  min-height: 79px;
  height: auto;
  padding: ${({ iconDelete }) =>
    iconDelete === "delete" ? "8px 40px 8px 8px" : "16px 80px 16px 16px"};
  border: 1px solid ${({ theme }) => theme?.colors?.neutral.neutral30};
  border-radius: ${({ iconDelete }) => (iconDelete === "delete" ? "8px" : "16px")};
  box-sizing: border-box;
  margin: 5px;

  ${getPaddingStyle}
  ${getMarginStyle}
`;

export const TitleCard = styled.div`
  font-family: Nunito-Sans;
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 4px;
  color: ${({ theme }) => theme?.colors?.neutral.neutral70};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const NameFile = styled.a`
  font-family: Nunito-Sans;
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 4px;
  color: ${({ theme }) => theme?.colors?.primary.default};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    font-family: Nunito-Sans-Bold;
    color: ${({ theme }) => theme?.colors?.primary.default};
  }
`;

export const SizeFile = styled.div`
  font-family: Nunito-Sans;
  font-size: 12px;
  line-height: 18px;
  color: ${({ theme }) => theme?.colors?.neutral.neutral70};
`;

export const DeleteIcon = styled(DeleteIconSvg)`
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  top: 8px;
  right: 8px;
`;

export const TrashIcon = styled(TrashIconSvg)`
  cursor: pointer;
  position: absolute;
  width: 24px;
  height: 26px;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
`;

export const SizeFile2 = styled.p`
  color: ${({ theme }) => theme?.colors?.primary.default};
  font-weight: 700;
`;

export const DownloadButton = styled(ButtonComponent)`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme?.colors?.neutral.neutral90};
  font-weight: 700;
  font-size: 13px;
  border-radius: 60px;
  padding: 8px;
  width: 100%;

  :hover {
    color: ${({ theme }) => theme?.colors?.neutral.neutral90};
  }
`;

export const DownloadIcon = styled(DownloadIconSvg)`
  bottom: 1px;
  position: relative;
  margin-right: 6px;
`;
